import consumer from "./consumer"
let current_user
let mode_user
consumer.subscriptions.create("RequestChannel", {
    connected() {
        // Called when the subscription is ready for use on the server
        current_user = $('#current_user_id').val()

        mode_user = $('#current_user_mode').val();
        let mode = mode_user === 'true'

        if (current_user !== "" && current_user !== "undefined" && current_user !== undefined && !mode) {
            let requestCount = sessionStorage.getItem('unreadRequestCount');
            if (requestCount !== null) {
                // If count is present in sessionStorage, use it
                updateRequestCount(requestCount);
            } else {
                $.ajax({
                    type: 'get',
                    url: '/unread_req_count',
                    success: function (data) {
                        let count = data.response.data;
                        // Save the count to sessionStorage (even if it's 0)
                        sessionStorage.setItem('unreadRequestCount', count);
                        updateRequestCount(count);
                    }
                })
            }
        }

    },

    disconnected() {
    },

    received(data) {
        let mode = mode_user === 'true'
        if (!mode && data.user_of_provider === parseInt(current_user) || data.delete_request) {
            $("#req").removeClass("d-block").addClass("d-none");
            $("#live-req").removeClass("d-none").addClass("d-block");
            let countData = $('#nav-req-count').text();
            if (countData === '' || countData === 'undefined'){
                countData = 0;
            }
            let newCount = parseInt(countData) + 1;
            $('#nav-req-count').text(newCount);
            sessionStorage.setItem('unreadRequestCount', String(newCount));
        }
    }
});

function updateRequestCount(count) {
    // If the count is 0, hide the count display and show the icon
    if (count > 0) {
        $('#nav-req-count').text(count).removeClass('d-none');
        $("#req").removeClass("d-block").addClass("d-none");
        $("#live-req").removeClass("d-none").addClass("d-block");
    } else {
        $('#nav-req-count').addClass('d-none');
        $("#live-req").removeClass("d-block").addClass("d-none");
        $("#req").removeClass("d-none").addClass("d-block");
    }
}
